import lottie from 'lottie-web';
import dataFinanceComp from './comps/finance_new/finance_web_2_data.json';
import dataGreenLand from './comps/green_land/green_land_web_2_data.json';
import dataMap from './comps/map/map_web_2_data.json';
import dataExpertise from './comps/expertise/expertise_web_2_data.json';
import dataSiteLayout from './comps/site_layout/site_layout_web_data.json';
import dataManagement from './comps/management/management_web_2_data.json';
import dataMarketing from './comps/marketing/marketing_web_3_data.json';
import dataDelivery from './comps/delivery/delivery_web_2_data.json';
import dataCommunity from './comps/community/community_web_data.json';
import dataDirectory from './comps/directory/directory_web_data.json';
import dataCelebrate from './comps/celebrate/celebrate_web_2_data.json';

class Animations {
  constructor() {
    // console.log('Animations constructor called');
    Animations.start();
  }

  static start() {
    // Thanks to: https://css-tricks.com/scroll-triggered-animation-vanilla-javascript/
    // Receiving options as an object
    // If the user doesn't pass any options, the default will be `{}`
    function scrollTrigger(selector, options = {}) {
      // Multiple element can have same class/selector,
      // so we are using querySelectorAll
      let els = document.querySelectorAll(selector);
      // The above `querySelectorAll` returns a nodeList,
      // so we are converting it to an array
      els = Array.from(els);
      // Now we are iterating over the elements array
      els.forEach(el => {
        // `addObserver function` will attach the IntersectionObserver to the element
        // Passing the options object to the addObserver function
        addObserver(el, options);
      });
    }

    // Receiving options passed from the scrollTrigger function
    function addObserver(el, options) {
      // We are creating a new IntersectionObserver instance
      let observer = new IntersectionObserver((entries, observer) => {
        // This takes a callback function that receives two arguments:
        // The elements list, and the observer instance.
        entries.forEach(entry => {
          // `entry.isIntersecting` will be true if the element is visible
          if (entry.isIntersecting) {
            if (options.cb) {
              // If we've passed a callback function, we'll call it
              options.cb(el);
            } else {
              // If we haven't, we'll just add the active class
              entry.target.classList.add('active');
            }
            // We are removing the observer from the element after adding the active class
            observer.unobserve(entry.target);
          }
        });
      }, options); // Passing the options object to the observer
      // Adding the observer to the element
      observer.observe(el);
    }

    // Preload images for upcoming lottie animation
    function preloadImages(imageRange, animationName) {
      for (let i = 0; i < imageRange; i += 1) {
        const imgIterate = i + 1;
        let imgNumber = 'img' + imgIterate;
        imgNumber = new Image();
        imgNumber.src = "'../../../../images/boxplus/" + animationName + "/img_" + i + ".png";
      }
    }

    // Example usage 1 (fire as soon as comes into view):
    scrollTrigger('[data-animation-reveal]');

    scrollTrigger('[data-text-slide-spare-land]', {
      threshold: 0.5,
      cb() {
        // Preload images for upcoming lottie animation
        preloadImages(5, 'green_land');
      },
    });

    scrollTrigger('[data-lottie-animation-green-land]', {
      threshold: 0.5,
      cb(el) {
        lottie.loadAnimation({
          container: el,
          renderer: 'svg',
          loop: false,
          autoplay: true,
          hideOnTransparent: true,
          animationData: dataGreenLand,
        });
      },
    });

    scrollTrigger('[data-text-slide-welcome]', {
      threshold: 0.5,
      cb() {
        preloadImages(1, 'map');
      },
    });

    scrollTrigger('[data-lottie-animation-map]', {
      threshold: 0.5,
      cb(el) {
        lottie.loadAnimation({
          container: el,
          renderer: 'svg',
          loop: false,
          autoplay: true,
          hideOnTransparent: true,
          animationData: dataMap,
        });

        preloadImages(9, 'expertise');
      },
    });

    scrollTrigger('[data-lottie-animation-expertise]', {
      threshold: 0.5,
      cb(el) {
        lottie.loadAnimation({
          container: el,
          renderer: 'svg',
          loop: false,
          autoplay: true,
          hideOnTransparent: true,
          animationData: dataExpertise,
        });
      },
    });

    scrollTrigger('[data-text-slide-maximise]', {
      threshold: 0.5,
      cb() {
        preloadImages(9, 'site_layout');
      },
    });

    scrollTrigger('[data-lottie-animation-site-layout]', {
      threshold: 0.5,
      cb(el) {
        lottie.loadAnimation({
          container: el,
          renderer: 'svg',
          loop: false,
          autoplay: true,
          hideOnTransparent: true,
          animationData: dataSiteLayout,
        });
      },
    });

    scrollTrigger('[data-text-slide-finance]', {
      threshold: 0.5,
      cb() {
        preloadImages(4, 'finance_new');
      },
    });

    scrollTrigger('[data-lottie-animation-finance]', {
      threshold: 0.5,
      cb(el) {
        lottie.loadAnimation({
          container: el,
          renderer: 'svg',
          loop: false,
          autoplay: true,
          hideOnTransparent: true,
          animationData: dataFinanceComp,
        });
      },
    });

    scrollTrigger('[data-text-slide-free-trial]', {
      threshold: 0.5,
      cb() {
        preloadImages(10, 'management');
      },
    });

    scrollTrigger('[data-lottie-animation-management]', {
      threshold: 0.5,
      cb(el) {
        lottie.loadAnimation({
          container: el,
          renderer: 'svg',
          loop: false,
          autoplay: true,
          hideOnTransparent: true,
          animationData: dataManagement,
        });
      },
    });

    scrollTrigger('[data-text-slide-marketing]', {
      threshold: 0.5,
      cb() {
        preloadImages(9, 'marketing');
      },
    });

    scrollTrigger('[data-lottie-animation-marketing]', {
      threshold: 0.5,
      cb(el) {
        lottie.loadAnimation({
          container: el,
          renderer: 'svg',
          loop: false,
          autoplay: true,
          hideOnTransparent: true,
          animationData: dataMarketing,
        });
      },
    });

    scrollTrigger('[data-text-slide-delivery]', {
      threshold: 0.5,
      cb() {
        preloadImages(11, 'delivery');
      },
    });

    scrollTrigger('[data-lottie-animation-delivery]', {
      threshold: 0.5,
      cb(el) {
        lottie.loadAnimation({
          container: el,
          renderer: 'svg',
          loop: false,
          autoplay: true,
          hideOnTransparent: true,
          animationData: dataDelivery,
        });
      },
    });

    scrollTrigger('[data-text-slide-community]', {
      threshold: 0.5,
      cb() {
        preloadImages(30, 'community');
      },
    });

    scrollTrigger('[data-lottie-animation-community]', {
      threshold: 0.5,
      cb(el) {
        lottie.loadAnimation({
          container: el,
          renderer: 'svg',
          loop: false,
          autoplay: true,
          hideOnTransparent: true,
          animationData: dataCommunity,
        });
      },
    });

    scrollTrigger('[data-text-slide-directory]', {
      threshold: 0.5,
      cb() {
        preloadImages(7, 'directory');
      },
    });

    scrollTrigger('[data-lottie-animation-directory]', {
      threshold: 0.5,
      cb(el) {
        lottie.loadAnimation({
          container: el,
          renderer: 'svg',
          loop: false,
          autoplay: true,
          hideOnTransparent: true,
          animationData: dataDirectory,
        });
      },
    });

    scrollTrigger('[data-text-slide-celebrate]', {
      threshold: 0.5,
      cb() {
        preloadImages(5, 'celebrate');
      },
    });

    scrollTrigger('[data-lottie-animation-celebrate]', {
      threshold: 0.5,
      cb(el) {
        lottie.loadAnimation({
          container: el,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          hideOnTransparent: true,
          animationData: dataCelebrate,
        });
      },
    });
  }
}

export default Animations;
